export const ACTION_RESET = 'FETCH_SEASON_RESET';
export const ACTION_REQUEST = 'FETCH_SEASON_REQUEST';
export const ACTION_SUCCESS = 'FETCH_SEASON_SUCCESS';
export const ACTION_ERROR = 'FETCH_SEASON_ERROR';
